import Accordion from "@components/Accordion";
import LBox from "@components/LBox";
import LIcon, { IconName } from "@components/LIcon";
import LText from "@components/LText";
import { ReactNode } from "react";

const AccountAccordion = ({
  children,
  iconColor,
  title,
  iconName,
}: {
  title: string;
  iconColor: string;
  iconName: Extract<IconName, "leaderboard" | "revenue">;
  children: ReactNode;
}) => {
  return (
    <Accordion gap="m1" title="account_accordion">
      <Accordion.Header>
        <LBox flexDirection="row" gap="m1" alignItems={"center"}>
          <LIcon colors={{ color: iconColor }} name={iconName} size={24} />
          <LText variant="bodyM2">{title}</LText>
        </LBox>
      </Accordion.Header>
      <Accordion.Content>{children}</Accordion.Content>
    </Accordion>
  );
};

export default AccountAccordion;
